type Props = {
  name: string;
  photoUrl?: string | null;
  size?: number;
};

function initialsFor(name: string): string {
  const parts = name.trim().split(/\s+/);
  const first = parts[0]?.[0] ?? "";
  const last = parts.length > 1 ? parts[parts.length - 1]?.[0] ?? "" : "";
  return (first + last).toUpperCase() || "·";
}

export default function Avatar({ name, photoUrl, size = 56 }: Props) {
  if (photoUrl) {
    return (
      <img
        src={photoUrl}
        alt=""
        width={size}
        height={size}
        style={{
          borderRadius: "50%",
          objectFit: "cover",
          flex: "0 0 auto",
        }}
      />
    );
  }
  return (
    <div
      aria-hidden="true"
      style={{
        width: size,
        height: size,
        flex: "0 0 auto",
        borderRadius: "50%",
        background: "var(--c-blush)",
        color: "var(--c-palm)",
        display: "grid",
        placeItems: "center",
        fontFamily: "var(--f-display)",
        fontStyle: "italic",
        fontWeight: 900,
        fontSize: size * 0.4,
        textTransform: "lowercase",
        userSelect: "none",
      }}
    >
      {initialsFor(name).toLowerCase()}
    </div>
  );
}
